<template>
  <div class="Report">
    <el-card style="margin-bottom: 20px">
      <el-form :model="userBookCaseHistoryVo" label-width="100px">
        <label
          style="
            font-weight: bold;
            margin-bottom: 20px;
            display: block;
            margin-top: 20px;
          "
          >基本信息</label
        >
        <el-row>
          <el-col :span="4">
            <el-form-item label="姓名">
              <el-input
                v-model="userBookCaseHistoryVo.hzxm"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="手机号">
              <el-input
                :value="userBookCaseHistoryVo.sjh"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="身份证号">
              <el-input
                v-model="userBookCaseHistoryVo.zjhm"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="科别">
              <el-input
                v-model="userBookCaseHistoryVo.ksmc"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="5">
          <el-form-item label="门诊号">
            <el-input
              v-model="userBookCaseHistoryVo.hosPatid"
              :disabled="true"
            ></el-input>
          </el-form-item>
        </el-col> -->
        </el-row>
      </el-form>
    </el-card>
    <el-radio-group v-model="checkedStatus" @change="tabchange">
      <el-radio-button
        v-for="state in states"
        :label="state.label"
        :key="state.text"
        >{{ state.text }}</el-radio-button
      >
    </el-radio-group>

    <el-table :data="gridData" v-show="sharedPrescription">
      <el-table-column property="tradedate" label="开方日期"></el-table-column>
      <el-table-column property="miname" label="医疗机构名称"></el-table-column>
      <el-table-column
        property="tradecuretype"
        label="医疗类别"
      ></el-table-column>
      <el-table-column
        property="tradefundtype"
        label="险种类型"
      ></el-table-column>
      <el-table-column property="recipeno" label="处方号码"></el-table-column>
      <el-table-column property="diag" label="处方诊断"></el-table-column>
      <el-table-column label="详情" width="130">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="small"
            @click.prevent="getDetails(scope.row)"
            >处方详情
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title :visible.sync="innerDrawer" width="80%">
      <el-table :data="durgData">
          <el-table-column
            property="fee_type"
            label="费用类别"
          ></el-table-column>
          <el-table-column property="itemname" label="名称"></el-table-column>
          <el-table-column
            property="specification"
            label="规格"
          ></el-table-column>
          <el-table-column
            property="dose"
            label="剂型"
          ></el-table-column>
          <el-table-column property="unitprice" label="单价"></el-table-column>
          <el-table-column property="count" label="数量"></el-table-column>
          <el-table-column property="unit" label="单位"></el-table-column>
          <el-table-column property="dosage" label="一次剂量"></el-table-column>
          <el-table-column property="minpackage" label="剂量单位"></el-table-column>
          <el-table-column property="howtouse" label="用法"></el-table-column>
          <el-table-column property="days" label="天数"></el-table-column>
          <el-table-column property="fee" label="总金额"></el-table-column>
        </el-table>
    </el-dialog>
    <el-table :data="PopupList1" border v-show="jianchaList">
      <el-table-column prop="inspectdate" label="日期"></el-table-column>
      <el-table-column prop="name" label="姓名"></el-table-column>
      <el-table-column
        prop="inspectitemname"
        label="检查内容"
      ></el-table-column>
      <el-table-column prop="sjdeptname" label="科室名称"></el-table-column>
      <el-table-column prop="sjdocname" label="医生名称"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            @click.prevent="goToDetails1(scope.row)"
            type="primary"
            size="small"
            >查看</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-table :data="PopupList" v-show="refuseDialogVisible" border>
      <el-table-column prop="assaydate" label="日期"></el-table-column>
      <el-table-column prop="name" label="姓名"></el-table-column>
      <el-table-column prop="assayname" label="检查内容"></el-table-column>
      <el-table-column prop="deptname" label="科室名称"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            @click.prevent="goToDetails(scope.row)"
            type="primary"
            size="small"
            >查看</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-table :data="PopupList2" border v-show="bingli">
      <el-table-column prop="outchtime" label="日期"></el-table-column>
      <el-table-column prop="name" label="姓名"></el-table-column>
      <el-table-column prop="deptname" label="就诊科室"></el-table-column>
      <el-table-column prop="doctorname" label="医生"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            @click.prevent="goToDetails2(scope.row.adminid, scope.row.patid)"
            type="primary"
            size="small"
            >查看</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-table :data="PopupList3" border v-show="chuyuan">
      <el-table-column prop="patientname" label="姓名"></el-table-column>
      <el-table-column prop="begintime" label="入院日期"></el-table-column>
      <el-table-column prop="endtime" label="出院日期"></el-table-column>
      <el-table-column prop="deptname" label="住院科室"></el-table-column>
      <el-table-column prop="wardname" label="住院病区"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            @click.prevent="goToDetails3(scope.row.inhospitalrecordnumber)"
            type="primary"
            size="small"
            >查看</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-card v-show="CheckList">
      <el-radio-group v-model="prescriptionStatus" @change="prescriptionchange">
        <el-radio-button
          v-for="state in prescriptiondata"
          :label="state.label"
          :key="state.text"
          >{{ state.text }}</el-radio-button
        >
      </el-radio-group>
      <el-table :data="PopupList4" border>
        <el-table-column prop="admLoc" label="收费项目"></el-table-column>
        <el-table-column prop="invDate" label="日期"></el-table-column>
        <el-table-column prop="invNo" label="发票号"></el-table-column>
        <el-table-column prop="totalAmount" label="合计金额"></el-table-column>
        <el-table-column prop="paycost" label="自付金额"></el-table-column>
        <el-table-column prop="chargeFlag" label="状态"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              @click.prevent="goToDetails4(scope.row)"
              type="primary"
              size="small"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-dialog title :visible.sync="choiceshow" width="70%">
      <el-table :data="obj" border>
        <el-table-column prop="name" label="姓名"></el-table-column>
        <el-table-column prop="medicalRecord" label="门诊号"></el-table-column>
        <el-table-column prop="idcard" label="身份证号"></el-table-column>
        <el-table-column prop="mobile" label="手机号"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              @click.prevent="determine(scope.row)"
              type="primary"
              size="small"
              >确定</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog title :visible.sync="InspectionReportDisplay" width="80%">
      <el-card>
        <el-form :inline="true" label-suffix="：" :model="detail">
          <el-form-item label="检查名称">{{
            detail.inspectitemname
          }}</el-form-item>
        </el-form>
      </el-card>
      <el-card>
        <div slot="header">患者信息</div>
        <el-form :inline="true" label-suffix="：" :model="detail">
          <el-form-item label="姓名">{{ detail.name }}</el-form-item>
          <el-form-item label="科室">{{ detail.sjdeptname }}</el-form-item>
          <el-form-item label="性别">{{
            detail.sex == "1" ? "男" : "女"
          }}</el-form-item>
          <el-form-item label="年龄">{{ detail.age }}</el-form-item>
          <el-form-item label="开单医生">{{ detail.sjdocname }}</el-form-item>
          <el-form-item label="开单日期">{{ detail.inspectdate }}</el-form-item>
          <el-form-item label="检查日期">{{ detail.checkdate }}</el-form-item>
          <el-form-item label="审核医生">{{
            detail.checkdocname
          }}</el-form-item>
        </el-form>
        <el-form>
          <el-form-item label="具体报告信息请以医院纸质报告为准"></el-form-item>
        </el-form>
      </el-card>
      <el-card>
        <el-form>
          <el-form-item label="检查结果"></el-form-item>
          <el-row>
            <el-col :span="24">
              <div class="grid-content bg-purple-dark">
                {{ detail.inspectresult }}
              </div>
            </el-col>
          </el-row>
        </el-form>
      </el-card>
      <el-card>
        <el-form>
          <el-form-item label="检查结果描述"></el-form-item>
          <el-row>
            <el-col :span="24">
              <div class="grid-content bg-purple-dark">
                {{ detail.inspectdes }}
              </div>
            </el-col>
          </el-row>
        </el-form>
      </el-card>
    </el-dialog>
    <el-dialog title :visible.sync="Inspection" width="70%">
      <el-card>
        <el-form :inline="true" label-suffix="：" :model="detail1">
          <el-form-item label="检验类别">{{ detail1.assayname }}</el-form-item>
          <el-form-item label="检验项目编号">{{
            detail1.assayno
          }}</el-form-item>
        </el-form>
      </el-card>
      <el-card>
        <div slot="header">患者信息</div>
        <el-form :inline="true" label-suffix="：" :model="detail1">
          <el-form-item label="姓名" style="min-width: 15%; width: 10%">{{
            detail1.name
          }}</el-form-item>
          <el-form-item label="性别" style="min-width: 15%; width: 10%">{{
            detail1.sex == "1" ? "男" : "女"
          }}</el-form-item>
          <el-form-item label="年龄" style="min-width: 15%; width: 10%">{{
            detail1.age
          }}</el-form-item>
          <el-form-item label="检验科室" style="min-width: 15%; width: 10%">{{
            detail1.deptname
          }}</el-form-item>
          <el-form-item label="报告时间" style="min-width: 15%; width: 10%">{{
            detail1.assaydate
          }}</el-form-item>
        </el-form>
        <el-form>
          <el-form-item label="与纸质报告有同等效力"></el-form-item>
        </el-form>
      </el-card>
      <el-card>
        <el-radio-group v-model="projecttab" @change="projectchange">
          <el-radio-button
            v-for="state in projectList"
            :label="state.label"
            :key="state.text"
            >{{ state.text }}</el-radio-button
          >
        </el-radio-group>
      </el-card>
      <el-card>
        <el-table :data="list1" border :row-style="rowClass">
          <el-table-column
            prop="assayitemcode"
            label="项目/单位"
          ></el-table-column>
          <el-table-column prop="result" label="结果"></el-table-column>
          <el-table-column prop="refrange" label="参考值"></el-table-column>
          <el-table-column prop="resultstate"></el-table-column>
        </el-table>
      </el-card>
    </el-dialog>
    <el-dialog title :visible.sync="CaseDisplay" width="70%">
      <el-card>
        <div slot="header">患者信息</div>
        <el-form :inline="true" label-suffix="：" :model="detail2">
          <el-form-item label="姓名">{{ detail2.name }}</el-form-item>
          <el-form-item label="性别">{{ detail2.sex }}</el-form-item>
          <el-form-item label="年龄">{{ detail2.age }}</el-form-item>
          <el-form-item label="科别">{{ detail2.deptname }}</el-form-item>
          <el-form-item label="时间">{{ detail2.outchtime }}</el-form-item>
          <el-form-item label="门诊号">{{ detail2.patid }}</el-form-item>
        </el-form>
      </el-card>
      <el-card>
        <div slot="header">
          <el-row>主诉：{{ detail2.zhusu }}</el-row>
          <el-row>现病史：{{ detail2.xianbing }}</el-row>
          <el-row>既往史：{{ detail2.jiwang }}</el-row>
          <el-row>药物过敏史：{{ detail2.guomin }}</el-row>
          <el-row>个人及家庭史：{{ detail2.geren }}</el-row>
          <el-row>体格检查：{{ detail2.jc_tige }}</el-row>
          <el-row>专科检查：{{ detail2.jc_zhuanke }}</el-row>
          <el-row>辅助检查：{{ detail2.jc_fuzhu }}</el-row>
          <el-row>诊断：{{ detail2.diagnosis }}</el-row>
          <el-row>处理：{{ detail2.chuli }}</el-row>
        </div>
      </el-card>
    </el-dialog>
    <el-dialog title :visible.sync="SummaryListDisplay" width="70%">
      <el-card>
        <div slot="header">北京燕化医院出院小结信息</div>
        <el-row>
          <el-col :span="24">
            <div
              class="grid-content bg-purple-dark"
              v-html="obj2.dischargenote"
            ></div>
          </el-col>
        </el-row>
      </el-card>
    </el-dialog>
    <el-dialog title :visible.sync="prescriptionDisplay" width="70%">
      <el-card>
        <div slot="header">处方信息</div>
        <el-form :inline="true" label-suffix="：" :model="detail5">
          <el-form-item label="合计金额">{{
            detail5.totalAmount
          }}</el-form-item>
          <el-form-item label="自付金额">{{ detail5.paycost }}</el-form-item>
          <el-form-item label="发票号">{{ detail5.invNo }}</el-form-item>
          <el-form-item label="时间">{{ detail5.invDate }}</el-form-item>
          <el-collapse
            v-model="activeNames"
            v-for="(item, index) in list5"
            :key="index"
          >
            <el-collapse-item :title="item.itemCatename" name="index">
              <div
                v-for="(item1, index1) in item.list"
                :key="index1"
                v-if="item.list"
              >
                就诊科室:{{ item.itemCateDesc }} 费用名称:{{ detail.admLoc }}
                {{ item1.itemCateDesc }}
                <span style="color: #ff9900">￥{{ item1.price }}</span>
                ({{ item1.qty }}/{{ item1.uom }})
                {{ item1.itemDesc }}
                用法:{{ item1.usage }}{{ item1.feq }}
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-form>
      </el-card>
    </el-dialog>
    <el-card v-show="bloodpressureDisplay">
      <el-radio-group
        v-model="bloodpressureStatus"
        @change="bloodpressurechange"
      >
        <el-radio-button
          v-for="state in bloodpressurestates"
          :label="state.label"
          :key="state.text"
          >{{ state.text }}</el-radio-button
        >
      </el-radio-group>
      <el-row style="text-align: center">
        <el-radio-group
          v-model="timeStatus"
          style="margin: 0 auto"
          @change="timechange"
        >
          <el-radio-button
            v-for="state in timestates"
            :label="state.label"
            :key="state.text"
            >{{ state.text }}</el-radio-button
          >
        </el-radio-group>
      </el-row>
      <el-row>
        <div id="chartLineBox" style="width: 100%; height: 50vh"></div>
        <el-table :data="bloodpressureList" border :cell-style="statusStyle">
          <el-table-column prop="formatTime" label="日期"></el-table-column>
          <el-table-column prop="sbp" label="收缩压"></el-table-column>
          <el-table-column prop="dbp" label="舒张压"></el-table-column>
          <el-table-column
            prop="sbpConslution.conclusion"
            label="收缩压描述"
          ></el-table-column>
          <el-table-column
            prop="dbpConslution.conclusion"
            label="舒张压描述"
          ></el-table-column>
        </el-table>
      </el-row>
    </el-card>
    <el-card v-show="bloodsugarDisplay">
      <el-row style="text-align: center">
        <el-radio-group
          v-model="timeStatus1"
          style="margin: 0 auto"
          @change="timechange1"
        >
          <el-radio-button
            v-for="state in timestates1"
            :label="state.label"
            :key="state.text"
            >{{ state.text }}</el-radio-button
          >
        </el-radio-group>
      </el-row>
      <el-row>
        <div id="chartLineBox1" style="width: 100%; height: 50vh"></div>
        <el-radio-group v-model="timeStatus3" @change="timechange2">
          <el-radio-button
            v-for="state in timestates3"
            :label="state.stdCode"
            :key="state.stdName"
            >{{ state.stdName }}</el-radio-button
          >
        </el-radio-group>
        <el-table :data="conclution" border>
          <el-table-column prop="formatTime" label="日期"></el-table-column>
          <el-table-column prop="formatGlucose" label="血糖"></el-table-column>
          <el-table-column prop="conclusion" label="血糖描述"></el-table-column>
        </el-table>
      </el-row>
    </el-card>
    <el-card v-show="heartrateDisplay">
      <el-radio-group v-model="bloodsugarStatus" @change="switchtab1">
        <el-radio-button
          v-for="state in bloodsugarstates"
          :label="state.label"
          :key="state.text"
          >{{ state.text }}</el-radio-button
        >
      </el-radio-group>
      <el-row style="text-align: center">
        <el-radio-group
          v-model="timeStatus2"
          style="margin: 0 auto"
          @change="switchtab"
        >
          <el-radio-button
            v-for="state in timestates2"
            :label="state.label"
            :key="state.text"
            >{{ state.text }}</el-radio-button
          >
        </el-radio-group>
      </el-row>
      <el-row>
        <div id="chartLineBox2" style="width: 100%; height: 50vh"></div>
        <el-table :data="bloodpressureList1" border :cell-style="statusStyle1">
          <el-table-column prop="formatTime" label="日期"></el-table-column>
          <el-table-column prop="pul" label="心率"></el-table-column>
          <el-table-column
            prop="pulConslution.conclusion"
            label="心率描述"
          ></el-table-column>
        </el-table>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import axiosUtil from "../../utils/AxiosUtils.js";
import echarts from "echarts";
const PAGE = {
  pageNum: 1,
  pageSize: 10,
  pages: 1,
  total: 0,
};
export default {
  data() {
    return {
      durgData: [],
      innerDrawer: false,
      gridData: [],
      PopupList3: [],
      bloodpressureList: [],
      bloodpressureList1: [],
      PopupList2: [],
      timeStatus3: "UNHANDLERGLUCOSESTDCODE",
      daterange: [],
      activeNames: ["1"],
      chuyuan: false,
      patName: "",
      jianchaList: true,
      sharedPrescription: false,
      display: false,
      obj: {},
      bianhao: [],
      choiceshow: false,
      CheckList: false,
      bingli: false,
      loading1: false,
      refuseDialogVisible: false,
      list: [],
      PopupList4: [],
      PopupList: [],
      PopupList1: [],
      states: [
        {
          label: "WAITCONTRACT",
          text: "检查报告",
        },
        {
          label: "CONTRACT",
          text: "检验报告",
        },
        {
          label: "CASE",
          text: "病历查询",
        },
        {
          label: "Summary",
          text: "出院小结",
        },
        {
          label: "prescription",
          text: "检查处方",
        },
        {
          label: "sharedPrescription",
          text: "共享处方查阅",
        },
        {
          label: "bloodpressure",
          text: "血压",
        },
        {
          label: "bloodsugar",
          text: "血糖",
        },
        {
          label: "heartrate",
          text: "心率",
        },
      ],
      projectList: [
        {
          label: "whole",
          text: "全部结果",
        },
        {
          label: "abnormal",
          text: "异常结果",
        },
      ],
      prescriptiondata: [
        {
          label: "Allprescriptions",
          text: "全部处方",
        },
        {
          label: "drugs",
          text: "药品处方",
        },
        {
          label: "inspect",
          text: "检查治疗",
        },
      ],
      prescriptionStatus: "Allprescriptions",
      projecttab: "whole",
      bloodpressurestates: [
        {
          label: "A",
          text: "数据A",
        },
        {
          label: "B",
          text: "数据B",
        },
      ],
      bloodsugarstates: [
        {
          label: "A",
          text: "数据A",
        },
        {
          label: "B",
          text: "数据B",
        },
      ],
      timestates: [
        {
          label: "week",
          text: "周",
        },
        {
          label: "month",
          text: "月",
        },
        {
          label: "year",
          text: "年",
        },
      ],
      timestates1: [
        {
          label: "week",
          text: "周",
        },
        {
          label: "month",
          text: "月",
        },
        {
          label: "year",
          text: "年",
        },
      ],
      timestates3: [],
      timestates2: [
        {
          label: "week",
          text: "周",
        },
        {
          label: "month",
          text: "月",
        },
        {
          label: "year",
          text: "年",
        },
      ],
      detail: {},
      InspectionReportDisplay: false,
      loading: false,
      page: PAGE,
      checkedStatus: "WAITCONTRACT",
      detail1: {},
      obj1: {},
      list1: [],
      Inspection: false,
      detail2: {},
      CaseDisplay: false,
      SummaryListDisplay: false,
      obj2: {},
      list5: {},
      prescriptionDisplay: false,
      detail5: {},
      bloodpressureDisplay: false,
      bloodpressureStatus: "A",
      timeStatus: "week",
      timeStatus1: "week",
      timeStatus2: "week",
      bloodsugarDisplay: false,
      bloodsugarStatus: "A",
      heartrateDisplay: false,
      conclution: [],
      listdata: [],
      listdata1: [],
      userBookCaseHistoryVo: {},
    };
  },
  mounted() {
    this.userBookCaseHistoryVo = this.$store.state.patientData;
    this.bianhao.idcard = this.userBookCaseHistoryVo.zjhm;
    this.bianhao.medicalRecord = this.userBookCaseHistoryVo.hosPatid;
    this.inspectList();
  },
  methods: {
    prescriptionchange() {
      if (this.prescriptionStatus == "drugs") {
        let projectdata = this.listdata1;
        this.PopupList4 = [];
        for (let i in projectdata) {
          if (projectdata[i].invoiceType == "处方") {
            this.PopupList4.push(projectdata[i]);
          }
        }
      } else if (this.prescriptionStatus == "inspect") {
        let projectdata = this.listdata1;
        this.PopupList4 = [];
        for (let i in projectdata) {
          if (projectdata[i].invoiceType == "检查") {
            this.PopupList4.push(projectdata[i]);
          }
        }
      } else if (this.prescriptionStatus == "Allprescriptions") {
        this.PopupList4 = this.listdata1;
      }
    },
    Trim(str) {
      //str表示要转换的字符串
      return str.replace(/\n|\r\n/g, "<br/>");
    },
    projectchange() {
      if (this.projecttab == "whole") {
        this.list1 = this.listdata;
      } else {
        let projectdata = this.list1;
        this.list1 = [];
        for (let i in projectdata) {
          if (projectdata[i].resultstate != "") {
            this.list1.push(projectdata[i]);
          }
        }
      }
    },
    rowClass({ row, rowIndex }) {
      if (row.resultstate != "") {
        return { color: "red" };
      }
    },
    switchtab1() {
      this.bloodpressureList1 = [];
      this.xinlvlist(this.timeStatus2, this.bloodsugarStatus);
    },
    switchtab() {
      this.bloodpressureList1 = [];
      this.xinlvlist(this.timeStatus2, this.bloodsugarStatus);
    },
    xinlvlist(timeStatus2, bloodsugarStatus) {
      let _this = this;
      axiosUtil(
        {
          service: "smarthos.device.data.pcandhis.bloodpressure.list",
          token: localStorage.getItem("token"),
          idCard: this.bianhao.idcard,
          periodType: timeStatus2,
        },
        ({ code, obj, page, msg }) => {
          if (code === "0") {
            let xAxisdata = [];
            let sup = [];
            let title = obj.time.formatStartTime + "~" + obj.time.formatEndTime;
            if (bloodsugarStatus == "B") {
              for (let i in obj.allDatasB) {
                xAxisdata.push(obj.allDatasB[i].formatTime);
                sup.push(obj.allDatasB[i].pul);
                for (let i in obj.allDatasB) {
                  _this.bloodpressureList1.push(obj.allDatasB[i]);
                }
              }
            } else {
              for (let i in obj.allDatasA) {
                xAxisdata.push(obj.allDatasA[i].formatTime);
                sup.push(obj.allDatasA[i].pul);
              }
              for (let i in obj.allDatasA) {
                _this.bloodpressureList1.push(obj.allDatasA[i]);
              }
            }
            // 指定图表的配置项和数据
            var option = {
              title: {
                text: title,
              },
              tooltip: {
                trigger: "axis",
              },
              legend: {
                data: ["心率"],
              },
              grid: {
                left: "3%",
                right: "4%",
                bottom: "3%",
                containLabel: true,
              },
              toolbox: {
                feature: {
                  saveAsImage: {},
                },
              },
              xAxis: {
                type: "category",
                boundaryGap: false,
                data: xAxisdata,
              },
              yAxis: {
                type: "value",
              },
              series: [
                {
                  name: "心率",
                  type: "line",
                  data: sup,
                },
              ],
            };
            // 使用刚指定的配置项和数据显示图表。
            this.$nextTick(function () {
              let chartBox = document.getElementById("chartLineBox2");
              var myChart = echarts.init(chartBox);
              myChart.setOption(option, true); //true用来解决数据不更新问题
            });
          } else {
            this.loading = false;
            this.bloodpressureList1 = [];
            this.$message.error(msg);
          }
        }
      );
    },
    bloodpressurechange() {
      this.bloodpressureList = [];
      this.xuyalist(this.timeStatus, this.bloodpressureStatus);
    },
    timechange() {
      this.bloodpressureList = [];
      this.xuyalist(this.timeStatus, this.bloodpressureStatus);
    },
    timechange1() {
      this.conclution = [];
      this.xutanglist(this.timeStatus1, this.timeStatus3);
    },
    timechange2() {
      this.conclution = [];
      this.xutanglist(this.timeStatus1, this.timeStatus3);
    },
    statusStyle({ row, column, rowIndex, columnIndex }) {
      if (
        this.bloodpressureList[rowIndex].dbpConslution.conclusionFlag != "0"
      ) {
        return "color:#ED3F14";
      }
    },
    statusStyle1({ row, column, rowIndex, columnIndex }) {
      if (
        this.bloodpressureList1[rowIndex].pulConslution.conclusionFlag != "0"
      ) {
        return "color:#ED3F14";
      }
    },
    xutanglist(periodType, timeStatus3) {
      let _this = this;
      axiosUtil(
        {
          service: "smarthos.device.data.pcandhis.glucose.list3",
          token: localStorage.getItem("token"),
          idCard: this.bianhao.idcard,
          stdCode: timeStatus3,
          periodType: periodType,
        },
        ({ code, obj, page, msg }) => {
          if (code === "0") {
            // 指定图表的配置项和数据
            let title = obj.time.formatStartTime + "~" + obj.time.formatEndTime;
            let formatTime = [];
            let glucose = [];
            for (let i in obj.datas) {
              formatTime.push(obj.datas[i].formatTime);
              glucose.push(obj.datas[i].glucose);
              this.conclution.push(obj.datas[i].conclution);
              this.conclution[i].formatTime = obj.datas[i].formatTime;
              this.conclution[i].formatGlucose = obj.datas[i].formatGlucose;
            }
            this.timestates3 = obj.marks;
            for (let i in this.timestates2) {
              if (this.timestates3[i].select) {
                this.timeStatus3 = this.timestates3[i].stdCode;
              }
            }
            var option = {
              title: {
                text: title,
              },
              tooltip: {
                trigger: "axis",
              },
              legend: {
                data: ["血糖"],
              },
              grid: {
                left: "3%",
                right: "4%",
                bottom: "3%",
                containLabel: true,
              },
              toolbox: {
                feature: {
                  saveAsImage: {},
                },
              },
              xAxis: {
                type: "category",
                boundaryGap: false,
                data: formatTime,
              },
              yAxis: {
                type: "value",
              },
              series: [
                {
                  name: "血糖",
                  type: "line",
                  data: glucose,
                },
              ],
            };
            // 使用刚指定的配置项和数据显示图表。
            this.$nextTick(function () {
              let chartBox = document.getElementById("chartLineBox1");
              var myChart = echarts.init(chartBox);
              myChart.setOption(option, true); //true用来解决数据不更新问题
            });
          } else {
            this.loading = false;
            this.$message.error(msg);
          }
        }
      );
    },
    xuyalist(periodType, bloodpressureStatus) {
      let _this = this;
      axiosUtil(
        {
          service: "smarthos.device.data.pcandhis.bloodpressure.list",
          token: localStorage.getItem("token"),
          idCard: this.bianhao.idcard,
          periodType: periodType,
        },
        ({ code, obj, page, msg }) => {
          if (code === "0") {
            let xAxisdata = [];
            let sup = [];
            let dbp = [];
            let title = obj.time.formatStartTime + "~" + obj.time.formatEndTime;
            if (bloodpressureStatus == "B") {
              for (let i in obj.allDatasB) {
                xAxisdata.push(obj.allDatasB[i].formatTime);
                sup.push(obj.allDatasB[i].sbp);
                dbp.push(obj.allDatasB[i].dbp);
                for (let i in obj.allDatasB) {
                  _this.bloodpressureList.push(obj.allDatasB[i]);
                }
              }
            } else {
              for (let i in obj.allDatasA) {
                xAxisdata.push(obj.allDatasA[i].formatTime);
                sup.push(obj.allDatasA[i].sbp);
                dbp.push(obj.allDatasA[i].dbp);
              }
              for (let i in obj.allDatasA) {
                _this.bloodpressureList.push(obj.allDatasA[i]);
              }
            }
            console.log(dbp);
            // 指定图表的配置项和数据
            var option = {
              title: {
                text: title,
              },
              tooltip: {
                trigger: "axis",
              },
              legend: {
                data: ["收缩压", "舒张压"],
              },
              grid: {
                left: "3%",
                right: "4%",
                bottom: "3%",
                containLabel: true,
              },
              toolbox: {
                feature: {
                  saveAsImage: {},
                },
              },
              xAxis: {
                type: "category",
                boundaryGap: false,
                data: xAxisdata,
              },
              yAxis: {
                type: "value",
              },
              series: [
                {
                  name: "收缩压",
                  type: "line",
                  data: sup,
                  markLine: {
                    symbol: "none",

                    /*symbol:"none",               //去掉警戒线最后面的箭头
                           label:{
                               position:"end"   ,       //将警示值放在哪个位置，三个值“start”,"middle","end"  开始  中点 结束
                            
                            
                           },*/
                    data: [
                      {
                        silent: false, //鼠标悬停事件  true没有，false有
                        lineStyle: {
                          //警戒线的样式  ，虚实  颜色
                          type: "dashed",
                          color: "#3398DB",
                        },
                        label: {
                          position: "end",
                          formatter: "",
                          fontSize: "14",
                        },
                        yAxis: 120, // 警戒线的标注值，可以有多个yAxis,多条警示线   或者采用   {type : 'average', name: '平均值'}，type值有  max  min  average，分为最大，最小，平均值
                      },
                      {
                        silent: false, //鼠标悬停事件  true没有，false有
                        lineStyle: {
                          //警戒线的样式  ，虚实  颜色
                          type: "dashed",
                          color: "#3398DB",
                        },
                        label: {
                          position: "end",
                          formatter: "",
                          fontSize: "14",
                        },
                        yAxis: 80, // 警戒线的标注值，可以有多个yAxis,多条警示线   或者采用   {type : 'average', name: '平均值'}，type值有  max  min  average，分为最大，最小，平均值
                      },
                    ],
                  },
                },
                {
                  name: "舒张压",
                  type: "line",
                  data: dbp,
                },
              ],
            };
            option.series[0].markPoint = {
              data: [
                {
                  type: "max",
                  name: "最大值",
                },
                {
                  type: "min",
                  name: "最小值",
                },
              ],
            };
            option.series[1].markPoint = {
              data: [
                {
                  type: "max",
                  name: "最大值",
                },
                {
                  type: "min",
                  name: "最小值",
                },
              ],
            };
            // 使用刚指定的配置项和数据显示图表。
            this.$nextTick(function () {
              let chartBox = document.getElementById("chartLineBox");
              var myChart = echarts.init(chartBox);
              myChart.setOption(option, true); //true用来解决数据不更新问题
            });
          } else {
            this.loading = false;
            this.$message.error(msg);
          }
        }
      );
      // myChart.setOption();
    },
    goToDetails2(adminid, patid) {
      axiosUtil(
        {
          service: "smarthos.examination.pat.medical.list",
          token: localStorage.getItem("token"),
          patId: patid,
        },
        ({ code, obj, msg }) => {
          if (obj.code === "0") {
            for (let i in obj.list) {
              if (obj.list[i].adminid == adminid) {
                this.detail2 = obj.list[i];
              }
            }
            this.CaseDisplay = true;
          } else {
            this.$message.error(obj.msg);
          }
        }
      );
    },
    goToDetails3(inhospitalrecordnumber) {
      let idcard = this.bianhao.idcard;
      let medicalRecord = this.bianhao.medicalRecord;
      axiosUtil(
        {
          service: "smarthos.yygh.discharge.summary.query.list",
          token: localStorage.getItem("token"),
          idcard: idcard,
          hosid: "01001",
          hospitalno: inhospitalrecordnumber,
          patientid: medicalRecord,
        },
        ({ code, dischargeSummaryList, msg }) => {
          if (code === "0") {
            dischargeSummaryList[0].dischargenote = this.Trim(
              dischargeSummaryList[0].dischargenote
            );
            this.obj2 = dischargeSummaryList[0];
            this.SummaryListDisplay = true;
          } else {
            this.$message.error(obj.msg);
          }
        }
      );
    },
    goToDetails4(row) {
      let idcard = this.bianhao.idcard;
      let jzkh = this.bianhao.medicalRecord;
      this.detail5 = row;
      axiosUtil(
        {
          service: "smarthos.yygh.ApiInvoiceService.detail",
          token: localStorage.getItem("token"),
          idcard: idcard,
          orgid:JSON.parse(sessionStorage.getItem("loginInfo")).doc.bookHosId,
          jzkh: jzkh,
          InvID: row.invNo,
        },
        ({ code, list, msg }) => {
          if (code === "0") {
            for (let i in list) {
              let idx = Number(i) + 1;
              list[i].itemCatename =
                "处方" + idx + " " + list[i].itemCateDesc + " " + list[i].fee;
              if (idx == list.length) {
                list[i].itemCatename = list[i].itemCateDesc + " " + list[i].fee;
              }
            }
            this.list5 = list;
            this.prescriptionDisplay = true;
          } else {
            this.$message.error(msg);
          }
        }
      );
    },
    Changelist() {
      this.PopupList1 = [];
      this.PopupList = [];
      this.PopupList2 = [];
      this.PopupList3 = [];
      this.PopupList4 = [];
    },
    tabchange() {
      // if (!this.bianhao.medicalRecord) {
      //   this.$message.error("请先输入身份证号或者医保卡号");
      //   return;
      // }
      if (this.checkedStatus == "WAITCONTRACT") {
        this.refuseDialogVisible = false;
        this.jianchaList = true;
        this.bingli = false;
        this.chuyuan = false;
        this.CheckList = false;
        this.bloodpressureDisplay = false;
        this.bloodsugarDisplay = false;
        this.sharedPrescription = false;
        this.heartrateDisplay = false;
        this.inspectList();
      } else if (this.checkedStatus == "CONTRACT") {
        this.refuseDialogVisible = true;
        this.jianchaList = false;
        this.bingli = false;
        this.chuyuan = false;
        this.CheckList = false;
        this.sharedPrescription = false;
        this.bloodpressureDisplay = false;
        this.bloodsugarDisplay = false;
        this.heartrateDisplay = false;
        this.testList();
      } else if (this.checkedStatus == "CASE") {
        this.bingli = true;
        this.refuseDialogVisible = false;
        this.jianchaList = false;
        this.chuyuan = false;
        this.sharedPrescription = false;
        this.CheckList = false;
        this.bloodpressureDisplay = false;
        this.bloodsugarDisplay = false;
        this.heartrateDisplay = false;
        this.bingliList();
      } else if (this.checkedStatus == "Summary") {
        this.bingli = false;
        this.refuseDialogVisible = false;
        this.sharedPrescription = false;
        this.jianchaList = false;
        this.chuyuan = true;
        this.CheckList = false;
        this.bloodpressureDisplay = false;
        this.bloodsugarDisplay = false;
        this.heartrateDisplay = false;
        this.chuyuanList();
      } else if (this.checkedStatus == "prescription") {
        this.bingli = false;
        this.refuseDialogVisible = false;
        this.jianchaList = false;
        this.chuyuan = false;
        this.sharedPrescription = false;
        this.CheckList = true;
        this.bloodpressureDisplay = false;
        this.bloodsugarDisplay = false;
        this.heartrateDisplay = false;
        this.Checktheprescription();
      } else if (this.checkedStatus == "bloodpressure") {
        this.bloodpressureDisplay = true;
        this.jianchaList = false;
        this.refuseDialogVisible = false;
        this.bingli = false;
        this.chuyuan = false;
        this.sharedPrescription = false;
        this.CheckList = false;
        this.bloodsugarDisplay = false;
        this.heartrateDisplay = false;
        this.bloodpressureList = [];
        this.xuyalist(this.timeStatus);
      } else if (this.checkedStatus == "bloodsugar") {
        this.bloodpressureDisplay = false;
        this.jianchaList = false;
        this.refuseDialogVisible = false;
        this.bingli = false;
        this.chuyuan = false;
        this.sharedPrescription = false;
        this.CheckList = false;
        this.bloodsugarDisplay = true;
        this.heartrateDisplay = false;
        this.conclution = [];
        this.xutanglist(this.timeStatus1, this.timeStatus3);
      } else if (this.checkedStatus == "heartrate") {
        this.heartrateDisplay = true;
        this.bloodpressureDisplay = false;
        this.jianchaList = false;
        this.refuseDialogVisible = false;
        this.bingli = false;
        this.chuyuan = false;
        this.sharedPrescription = false;
        this.CheckList = false;
        this.bloodsugarDisplay = false;
        this.bloodpressureList1 = [];
        this.xinlvlist(this.timeStatus2, this.bloodsugarStatus);
      } else if (this.checkedStatus == "sharedPrescription") {
        this.heartrateDisplay = false;
        this.bloodpressureDisplay = false;
        this.jianchaList = false;
        this.refuseDialogVisible = false;
        this.bingli = false;
        this.chuyuan = false;
        this.sharedPrescription = true;
        this.CheckList = false;
        this.bloodsugarDisplay = false;
        this.bloodpressureList1 = [];
        this.sharedPrescriptionList();
      }
    },
    getDetails(row) {
      this.durgData = row.itemlist.item;
      this.innerDrawer = true;
    },
    sharedPrescriptionList() {
      let that = this;
      axiosUtil(
        {
          service: "smarthos.yygh.ApiyGHpaymentService.prescription.record",
          token: localStorage.getItem("token"),
          ddid: that.userBookCaseHistoryVo.ddid,
          orgid: JSON.parse(sessionStorage.getItem("loginInfo")).doc.bookHosId,
        },
        ({ code, recipeList }) => {
          if (code == "0") {
            that.gridData = recipeList;
          }
        }
      );
    },
    Checktheprescription() {
      axiosUtil(
        {
          service: "smarthos.prescription.check.list",
          token: localStorage.getItem("token"),
          idcard: this.bianhao.idcard,
          orgid: JSON.parse(sessionStorage.getItem("loginInfo")).doc.bookHosId,
          jzkh: this.bianhao.medicalRecord,
        },
        ({ code, list }) => {
          if (code === "0") {
            console.log();
            if (JSON.stringify(list) != "[]") {
              for (let i in list) {
                if (list[i].invoiceType == "处方") {
                  list[i].admLoc = "药品处方";
                } else if (list[i].invoiceType == "检查") {
                  list[i].admLoc = "检查治疗";
                } else if (list[i].invoiceType == "处方+检查") {
                  list[i].admLoc = "药品处方+检查治疗";
                }
                this.PopupList4.push(list[i]);
                this.listdata1.push(list[i]);
              }
            } else {
              this.$message("暂无数据");
            }
          } else {
            this.$message("暂无数据");
          }
        }
      );
    },
    determine(row) {
      this.bianhao = row;
      this.choiceshow = false;
      if (this.checkedStatus == "WAITCONTRACT") {
        this.refuseDialogVisible = false;
        this.jianchaList = true;
        this.bingli = false;
        this.bloodpressureDisplay = false;
        this.bloodsugarDisplay = false;
        this.heartrateDisplay = false;
        this.chuyuan = false;
        this.CheckList = false;
        this.inspectList();
      } else if (this.checkedStatus == "CONTRACT") {
        this.refuseDialogVisible = true;
        this.jianchaList = false;
        this.bingli = false;
        this.bloodpressureDisplay = false;
        this.bloodsugarDisplay = false;
        this.heartrateDisplay = false;
        this.CheckList = false;
        this.chuyuan = false;
        this.testList();
      } else if (this.checkedStatus == "CASE") {
        this.bingli = true;
        this.refuseDialogVisible = false;
        this.jianchaList = false;
        this.bloodpressureDisplay = false;
        this.bloodsugarDisplay = false;
        this.heartrateDisplay = false;
        this.chuyuan = false;
        this.CheckList = false;
        this.bingliList();
      } else if (this.checkedStatus == "Summary") {
        this.bingli = false;
        this.refuseDialogVisible = false;
        this.jianchaList = false;
        this.chuyuan = true;
        this.bloodpressureDisplay = false;
        this.bloodsugarDisplay = false;
        this.heartrateDisplay = false;
        this.CheckList = false;
        this.chuyuanList();
      } else if (this.checkedStatus == "prescription") {
        this.bingli = false;
        this.refuseDialogVisible = false;
        this.jianchaList = false;
        this.chuyuan = false;
        this.CheckList = true;
        this.bloodpressureDisplay = false;
        this.bloodsugarDisplay = false;
        this.heartrateDisplay = false;
        this.Checktheprescription();
      } else if (this.checkedStatus == "bloodpressure") {
        this.bloodpressureDisplay = true;
        this.jianchaList = false;
        this.refuseDialogVisible = false;
        this.bingli = false;
        this.chuyuan = false;
        this.CheckList = false;
        this.bloodsugarDisplay = false;
        this.heartrateDisplay = false;
        this.bloodpressureList = [];
        this.xuyalist(this.timeStatus);
      } else if (this.checkedStatus == "bloodsugar") {
        this.bloodpressureDisplay = false;
        this.jianchaList = false;
        this.refuseDialogVisible = false;
        this.bingli = false;
        this.chuyuan = false;
        this.CheckList = false;
        this.bloodsugarDisplay = true;
        this.heartrateDisplay = false;
        this.conclution = [];
        this.xutanglist(this.timeStatus1, this.timeStatus3);
      } else if (this.checkedStatus == "heartrate") {
        this.heartrateDisplay = true;
        this.bloodpressureDisplay = false;
        this.jianchaList = false;
        this.refuseDialogVisible = false;
        this.bingli = false;
        this.chuyuan = false;
        this.CheckList = false;
        this.bloodsugarDisplay = false;
        this.bloodpressureList1 = [];
        this.xinlvlist(this.timeStatus2, this.bloodsugarStatus);
      }
    },
    chuyuanList() {
      axiosUtil(
        {
          service: "smarthos.yygh.ApiPrepaidInpatientGoldService.zyryxx",
          token: localStorage.getItem("token"),
          orgid: JSON.parse(sessionStorage.getItem("loginInfo")).doc.bookHosId,
          idcard: this.bianhao.idcard,
          idcardtype: "0",
        },
        ({ code, list, msg }) => {
          if (code === "0") {
            if (list) {
              this.PopupList3 = list;
            } else {
              this.$message(msg);
            }
          } else {
            this.$message.error(msg);
          }
        }
      );
    },
    testList() {
      var date = new Date();
      var y = date.getFullYear() - 1; // 减一是算去年时间，+ 1 是明年时间
      var m = date.getMonth() + 1;
      var d = date.getDate();
      if (m < 10) {
        m = "0" + m;
      }
      if (d < 10) {
        d = "0" + d;
      }
      let startdate = String(y) + String(m) + String(d);

      var nowdate = new Date();
      var y1 = nowdate.getFullYear();
      var m1 = nowdate.getMonth() + 1;
      var d1 = nowdate.getDate();
      if (m1 < 10) {
        m1 = "0" + m1;
      }
      if (d1 < 10) {
        d1 = "0" + d1;
      }
      let enddate = y1 + m1 + d1;
      this.loading1 = true;
      axiosUtil(
        {
          service: "smarthos.yygh.apiQueryInspectionService.selectExamList",
          token: localStorage.getItem("token"),
          hosid: JSON.parse(sessionStorage.getItem("loginInfo")).doc.hosId,
          orgid: JSON.parse(sessionStorage.getItem("loginInfo")).doc.bookHosId,
          idcard: this.bianhao.idcard,
          bdate: startdate,
          edate: enddate,
          medcardno: this.bianhao.medicalRecord,
        },
        ({ code, list, msg }) => {
          this.loading1 = false;
          if (code === "0") {
            if (list) {
              this.PopupList = list;
            } else {
              this.$message("暂无数据");
            }
          } else {
            this.$message.error(msg);
          }
        }
      );
    },
    inspectList() {
      var date = new Date();
      var y = date.getFullYear() - 1; // 减一是算去年时间，+ 1 是明年时间
      var m = date.getMonth() + 1;
      var d = date.getDate();
      if (m < 10) {
        m = "0" + m;
      }
      if (d < 10) {
        d = "0" + d;
      }
      let startdate = String(y) + String(m) + String(d);

      var nowdate = new Date();
      var y1 = nowdate.getFullYear();
      var m1 = nowdate.getMonth() + 1;
      var d1 = nowdate.getDate();
      if (m1 < 10) {
        m1 = "0" + m1;
      }
      if (d1 < 10) {
        d1 = "0" + d1;
      }
      let enddate = y1 + m1 + d1;
      this.loading1 = true;

      axiosUtil(
        {
          service: "smarthos.yygh.apiQueryInspectionService.selectCheckList",
          token: localStorage.getItem("token"),
          hosid: JSON.parse(sessionStorage.getItem("loginInfo")).doc.hosId,
          orgid: JSON.parse(sessionStorage.getItem("loginInfo")).doc.bookHosId,
          idcard: this.bianhao.idcard,
          bdate: startdate,
          edate: enddate,
          medcardno: this.bianhao.medicalRecord,
        },
        ({ code, list, msg }) => {
          this.loading1 = false;
          if (code === "0") {
            if (list) {
              this.PopupList1 = list;
            } else {
              this.$message("暂无数据");
            }
          } else {
            this.$message.error(msg);
          }
        }
      );
    },
    choice() {
      if (!this.bianhao.medicalRecord) {
        this.$message.error("请先输入患者身份证号或医保卡号");
        return;
      }
      this.choiceshow = true;
    },

    goToDetails(row) {
      let assayno = row.assayno;
      this.detail1 = row;
      axiosUtil(
        {
          service: "smarthos.yygh.apiQueryInspectionService.selectExamInfo",
          token: localStorage.getItem("token"),
          assayno: assayno,
          orgid: JSON.parse(sessionStorage.getItem("loginInfo")).doc.bookHosId,
          hosid: JSON.parse(sessionStorage.getItem("loginInfo")).doc.hosId,
        },
        ({ code, list, msg }) => {
          if (code === "0") {
            this.obj1 = list[0];

            for (let i in list) {
              list[i].assayitemcode =
                list[i].assayitemcode + "   " + list[i].unit;
              this.list1.push(list[i]);
              this.listdata.push(list[i]);
            }
            this.Inspection = true;
            if (this.projecttab == "abnormal") {
              let projectdata = this.list1;
              this.list1 = [];
              for (let i in projectdata) {
                if (projectdata[i].resultstate != "") {
                  this.list1.push(projectdata[i]);
                }
              }
            }
          } else {
            this.$message.error(obj.msg);
          }
        }
      );
    },
    goToDetails1(row) {
      this.detail = row;
      this.InspectionReportDisplay = true;
      // localStorage.setItem("jiancha", JSON.stringify(row));
      // this.$router.push({
      //   path: "/main/jianchaDetails",
      //   query: {},
      // });
    },
    onSubmit() {
      if (this.patName == "") {
        this.$message.error("请输入身份证号或医保卡号");
        return;
      }
      this.getList();
    },
    bingliList() {
      axiosUtil(
        {
          service: "smarthos.examination.pat.medical.list",
          token: localStorage.getItem("token"),
          patId: this.bianhao.medicalRecord,
        },
        ({ code, obj, msg }) => {
          this.loading1 = false;
          if (obj.code === "0") {
            this.PopupList2 = obj.list;
          } else {
            this.$message.error(obj.msg);
          }
        }
      );
    },
    onCurrentChange(pageNum) {
      this.page.pageNum = pageNum;
      // this.getList();
    },
    getList() {
      this.loading = true;
      axiosUtil(
        {
          service: "smarhos.referral.patient.list",
          token: localStorage.getItem("token"),
          search: this.patName,
          bookHosId: JSON.parse(sessionStorage.getItem("loginInfo")).doc.bookHosId,
        },
        ({ code, list, page, msg }) => {
          if (code === "0") {
            this.loading = false;
            this.bianhao = list[0];
            this.obj = list;
            if (this.checkedStatus == "WAITCONTRACT") {
              this.bloodpressureDisplay = false;
              this.jianchaList = true;
              this.refuseDialogVisible = false;
              this.bingli = false;
              this.chuyuan = false;
              this.CheckList = false;
              this.bloodsugarDisplay = false;
              this.heartrateDisplay = false;
              this.inspectList();
            } else if (this.checkedStatus == "CONTRACT") {
              this.bloodpressureDisplay = false;
              this.jianchaList = false;
              this.refuseDialogVisible = true;
              this.bingli = false;
              this.chuyuan = false;
              this.CheckList = false;
              this.bloodsugarDisplay = false;
              this.heartrateDisplay = false;
              this.testList();
            } else if (this.checkedStatus == "CASE") {
              this.bloodpressureDisplay = false;
              this.jianchaList = false;
              this.refuseDialogVisible = false;
              this.bingli = true;
              this.chuyuan = false;
              this.CheckList = false;
              this.bloodsugarDisplay = false;
              this.heartrateDisplay = false;
              this.bingliList();
            } else if (this.checkedStatus == "Summary") {
              this.bloodpressureDisplay = false;
              this.jianchaList = false;
              this.refuseDialogVisible = false;
              this.bingli = false;
              this.chuyuan = true;
              this.CheckList = false;
              this.bloodsugarDisplay = false;
              this.heartrateDisplay = false;
              this.chuyuanList();
            } else if (this.checkedStatus == "prescription") {
              this.bloodpressureDisplay = false;
              this.jianchaList = false;
              this.refuseDialogVisible = false;
              this.bingli = false;
              this.chuyuan = false;
              this.CheckList = true;
              this.bloodsugarDisplay = false;
              this.heartrateDisplay = false;
              this.Checktheprescription();
            } else if (this.checkedStatus == "bloodpressure") {
              this.bloodpressureDisplay = true;
              this.jianchaList = false;
              this.refuseDialogVisible = false;
              this.bingli = false;
              this.chuyuan = false;
              this.CheckList = false;
              this.bloodsugarDisplay = false;
              this.heartrateDisplay = false;
              this.bloodpressureList = [];
              this.xuyalist(this.timeStatus);
            } else if (this.checkedStatus == "bloodsugar") {
              this.bloodpressureDisplay = false;
              this.jianchaList = false;
              this.refuseDialogVisible = false;
              this.bingli = false;
              this.chuyuan = false;
              this.CheckList = false;
              this.bloodsugarDisplay = true;
              this.heartrateDisplay = false;
              this.conclution = [];
              this.xutanglist(this.timeStatus1, this.timeStatus3);
            } else if (this.checkedStatus == "heartrate") {
              this.heartrateDisplay = true;
              this.bloodpressureDisplay = false;
              this.jianchaList = false;
              this.refuseDialogVisible = false;
              this.bingli = false;
              this.chuyuan = false;
              this.CheckList = false;
              this.bloodsugarDisplay = false;
              this.bloodpressureList1 = [];
              this.xinlvlist(this.timeStatus2, this.bloodsugarStatus);
            }
          } else {
            this.loading = false;
            this.$message.error(msg);
          }
        }
      );
    },
  },
};
</script>

<style lang="scss">
.Report {
  .el-table {
    margin-top: 15px;
  }
  .pagination-wrapper {
    padding: 20px 0;
  }
  .el-table .cell {
    max-height: 69px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }
}
.el-dialog__body {
  height: auto !important;
}
</style>
